module.exports = __webpack_public_path__ + "img/modal-frame.65d0a2ab.png";